export const CHANGE_VALUE_TICK_DELAY = 60;
export const START_AUTO_CHANGE_DELAY = 400;
export const SCROLLING_POINTER_MOVE_DISTANCE = 8;
